import updateContactPreferences from './api';
import { send } from 'server';

export const INIT_PREFERENCES = 'INIT_CONTACT_PREFERENCES';
export const CHANGE_PREFERENCES = 'CHANGE_CONTACT_PREFERENCES';
export const CHANGE_ALL_PREFERENCES = 'CHANGE_ALL_CONTACT_PREFERENCES';

export const initPreferencesAction = ({ promotional, account, thirdParty }) => ({
    type: INIT_PREFERENCES,
    payload: {
        promotional,
        account,
        thirdParty
    }
});

export const changePreferencesAction = (checked, type, index) => ({
    type: CHANGE_PREFERENCES,
    payload: {
        checked,
        type,
        index
    }
});

export const changeAllPreferencesAction = (checked, type) => ({
    type: CHANGE_ALL_PREFERENCES,
    payload: {
        checked,
        type
    }
});

export const setContactPreferences = contactPreferences => send({
    ID: 35513,
    description: 'Set user contact preferences',
    responses: [35514, 35515],
    contactPreferences
});

export const setPlayerTag = tag => send({
    ID: 35544,
    description: 'Set tags for contact preferences',
    responses: [35545, 35546],
    tags: [
        {
            ...tag
        }
    ]
});

export const updateUserContactPreferences = contactPreferences =>
    updateContactPreferences(contactPreferences);
